import {z} from 'zod';

export const conversationParams = z.object({
  conversationId: z.string().uuid().min(1, 'Conversation ID is required').uuid().openapi({
    description: 'ID of the conversation',
    example: '123e4567-e89b-12d3-a456-426614174000',
  }),
});

export type ConversationParams = z.infer<typeof conversationParams>;
